<template>
  <FaqBox :site="site" :filter="filter" />

  <ComponentStyles>
    .faqSearchResult:hover { background-color:
    lightgray !important; } .web-faq-slide-enter-active { transition: all 0.3s
    ease-in; } .web-faq-slide-leave-to, .web-faq-slide-enter-from { transform:
    height; opacity: 0; height: 0; }
    .accordion-button:not(.collapsed) { color: black; background-color: inherit;  }
    .accordion-button::after {left: 1rem; }
  </ComponentStyles>
</template>

<script>
import ComponentStyles from "../componentStyles.vue";
import FaqBox from "./FaqBoxTEST.vue";
export default {
  props: ["site", "filter"],

  data() {
    let toggle = "faq";

    let theme = {
      cat: "background: #0C555B; color: #FFFFFF;",
      catActive: "background : #F0CC83; color: #47525D;",
    };

    if (this.site == "gn") {
      theme = {
        cat: "background: #0C555B !important; color: #FFFFFF;",
        catActive: "background : #F0CC83; color: #47525D;",
      };
    }

    return {
      theme,
      toggle,
    };
  },

  components: { ComponentStyles, FaqBox },

  methods: {},

  watch: {},

  mounted() {},
};
</script>
